<template>
<v-container fluid>
  <v-row>
    <v-col>
      <v-card>
        <v-toolbar  color="#1a68a4"
                    dark
                    flat>
          <v-toolbar-title class="ml-3">Bulk Download</v-toolbar-title>
        </v-toolbar>
          <v-card-title>
            Please select financing category and date range
          </v-card-title>
        <v-container fluid>
          <v-row>
            <v-col md="3">
              <v-select
                label="Financing Category"
                solo
                deletable-chips
                chips
                small-chips>

              </v-select>
            </v-col>
            <v-col md="3">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    label="Start Date"
                    prepend-icon="mdi-event"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="3">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    label="End Date"
                    prepend-icon="mdi-event"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="3">
              <v-btn color="info">Request</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-card-title>Request History</v-card-title>
          </v-row>
          <v-row>
            <v-col md="10">
              <v-simple-table fixed-header height="300px">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">Sl. No</th>
                    <th class="text-left">Financing Category</th>
                    <th class="text-left">Date Range</th>
                    <th class="text-left">Request Reports</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in desserts" :key="item.name">
                    <td>{{item.no}}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.calories }}</td>
                    <td>
                      <v-btn v-if="item.download === 'Processing'" color="info">Processing</v-btn>
                      <v-btn v-if="item.download === 'Cancel'" dark color="red">Cancel</v-btn></td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  name: 'BulkDownload',
  data () {
    return {
      desserts: [
        {
          no: '1',
          name: 'Frozen Yogurt',
          calories: '26-10-2019 / 6-11-2019',
          download: 'Processing'
        },
        {
          no: '2',
          name: 'Ice cream sandwich',
          calories: '24-09-2019 / 14-10-2019',
          download: 'Cancel'
        },
        {
          no: '3',
          name: 'Eclair',
          calories: '10-08-2019 / 01-09-2019',
          download: 'Processing'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
